import React, { useEffect, useMemo, useState } from 'react';
import UserService from '../services/user/UserService';

const UPT = ({ id }) => {
    let userService = useMemo(() => new UserService(), [])
    const [urUpt, setUrUpt] = useState('')

    useEffect(() => {
        const getUpt = async () => {
            try {
                const response = await userService.getUptById(id)
                setUrUpt(response.data.nmUnit)
            } catch (error) {
                setUrUpt('')
            }
        }
        getUpt()
    }, [userService, id])

    return (
        <>
            {urUpt}
        </>
    )
}

export default UPT